import { render, staticRenderFns } from "./VideoSetting.vue?vue&type=template&id=1866ffec&scoped=true&"
import script from "./VideoSetting.vue?vue&type=script&lang=js&"
export * from "./VideoSetting.vue?vue&type=script&lang=js&"
import style0 from "./VideoSetting.vue?vue&type=style&index=0&id=1866ffec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1866ffec",
  null
  
)

export default component.exports